(() => {
  const checkoutLabel = document.currentScript.dataset.checkoutLabel;
  const buttonId = 'zonos--checkout-hidden-international-button';

  const labelInternationalCheckout = () => {
    const button = document.getElementById(buttonId);
    if (!button || button.textContent.trim() || button.getAttribute('aria-label')?.trim()) return;

    const labelledBy = button.getAttribute('aria-labelledby')?.trim().split(/\s+/) || [];
    if (labelledBy.some(id => document.getElementById(id)?.textContent.trim())) return;

    button.setAttribute('aria-label', checkoutLabel);
  };

  labelInternationalCheckout();
  new MutationObserver(labelInternationalCheckout).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['id', 'aria-label', 'aria-labelledby']
  });
})();
